import { EditorDataResponse } from "../../../api/v2/types";
import { LocalesList } from "../../../types/Locales";

const toMetadata = (locale: EditorDataResponse["json"][number]["metadata"]): LocalesList["metadata"] => ({
  type: "file",
  size: 0,
  name: locale.name,
  path: locale.path,
  sha: "",
  url: "",
  git_url: null,
  html_url: null,
  download_url: null,
  _links: {
    self: "",
    git: "",
    html: "",
  },
});

export const adaptEditorDataToLocalesList = (
  editorData: EditorDataResponse
): LocalesList[] => {
  return editorData.json.map((locale) => ({
    metadata: toMetadata(locale.metadata),
    content: locale.content,
  }));
};

export const buildSavePayload = (
  locales: LocalesList[]
): Array<{ filePath: string; content: Record<string, unknown> }> =>
  locales.map((locale) => ({
    filePath: locale.metadata.path,
    content: locale.content,
  }));
